import React from 'react';
import classnames from 'classnames';

export interface Props {
  open: () => any;
  close: () => any;
  className?: string;
}

const InfoButton = ({ open, close, className }: React.PropsWithChildren<Props>) => (
  <span
    className={classnames(
      'absolute ml-1 w-3 text-center leading-3 bg-gray rounded-full bold text-[0.625rem] lowercase text-gray-lightest transition group-hover:bg-red hover:cursor-pointer',
      className
    )}
    onMouseOver={open}
    onMouseOut={close}
  >
    i
  </span>
);

export default InfoButton;
